import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

import { Heading } from "../Heading";

const MagazineBlockItemHeading = styled(Heading)`
  height: 3.5em;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-transform: none;
  @media screen and (max-width: ${themeGet("breakpoints.sm")}) {
    -webkit-line-clamp: none;
    height: auto;
  }
`;

MagazineBlockItemHeading.defaultProps = {
  as: "h4",
  fontWeight: "normal",
  fontSize: ["15px", 4],
  color: "link",
  lineHeight: 1,
  mb: [2, "0"],
};

export { MagazineBlockItemHeading };
